import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl } from "./services";

const WithDrawal = () => {
  const [WalletData, setWalletData] = useState([]);
  const [WalletDataHistory, setWalletDataHistory] = useState([]);

  const [WithDrawalAmount, setWithDrawalAmount] = useState(10);

  const [BankDetails, setBankDetails] = useState([]);
  const [UserWithdrawalCNT, setUserWithdrawalCNT] = useState(0);

  const UserID = localStorage.getItem("UserID");

  const GetUserWallet = async () => {
    await axios({
      method: "GET",
      url: MyApiUrl + "EarningWallet/" + UserID + "",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        axios({
          method: "GET",
          url: MyApiUrl + "UserWithdrawalHistory/" + UserID + "",
          headers: {
            "content-type": "application/json",
          },
        })
          .then((response1) => {
            setWalletDataHistory(response1.data);
          })
          .catch((error) => {
            console.log(error);
          });
        setWalletData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const YourBankDetails = async () => {
    await axios({
      method: "GET",
      url: MyApiUrl + "GetBankDetails/" + UserID + "",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        setBankDetails(response.data);
        UserWithdrawalCount();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const UserWithdrawalCount = () => {
    axios({
      method: "GET",
      url: MyApiUrl + "GetUserWithdrawalCount/" + UserID + "",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.length > 0) {
          if (
            parseInt(response.data[0].withdrawal_status) === 1 ||
            parseInt(response.data[0].withdrawal_status) === 0
          ) {
            setUserWithdrawalCNT(1);
          } else {
            setUserWithdrawalCNT(0);
          }
        } else {
          setUserWithdrawalCNT(0);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SplitDate = (Date) => {
    let Datee = Date.split("T")[0].split("-");
    console.log(Datee);
    return `${Datee[2]}-${Datee[1]}-${Datee[0]}`;
  };

  const WithDraw = () => {
    const currentHour = new Date().getHours();

    if (currentHour < 9 || currentHour >= 18) {
      alert("Withdrawal requests are allowed only between 9 AM and 6 PM.");
    } else {
      if (BankDetails.length === 0) {
        alert("Please add bank details before withdrawal");
      } else {
        if (WithDrawalAmount === "" || WithDrawalAmount === null) {
          alert("Please Enter Withdrawal Amount");
        } else if (WithDrawalAmount < 10) {
          alert("Minimum Withdrawal Amount is 10");
        } else if (
          WithDrawalAmount > WalletData[0].wallet_balance ||
          WalletData[0].wallet_balance < 0
        ) {
          alert("Insufficient Wallet Balance");
        } else {
          var obj = {
            Amount: WithDrawalAmount,
            UserID: UserID,
          };
          axios.post(MyApiUrl + "UserWithdrawal", obj).then((response) => {
            if (response.data) {
              alert(
                "Withdrawal request sent successful, please wait for admin approval."
              );
              setWithDrawalAmount(100);
              GetUserWallet();
              UserWithdrawalCount();
            } else if (response.data === false) {
              alert("Withdrawal Failed");
            }
          });
        }
      }
    }
  };

  React.useEffect(() => {
    YourBankDetails();
    GetUserWallet();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <section
          className="content-inner section-wrapper3 overflow-hidden"
          style={{ paddingTop: "7em" }}
        >
          <div className="container">
            <div className="section-head text-center">
              <h2 className="title wow fadeInUp" data-wow-delay="0.4s">
                Earning / Wallet
              </h2>
            </div>
            <div className="row">
              <div
                className="col-xl-6 col-md-6 wow fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="icon-bx-wraper style-1 box-hover active">
                  <div className="icon-content">
                    <h5 className="dz-title m-b10">
                      <a href="#">
                        ₹{" "}
                        {WalletData.length > 0
                          ? parseFloat(WalletData[0].total_earning).toFixed(2)
                          : 0}
                      </a>
                    </h5>
                    <p className="m-b25">Earning Wallet</p>
                  </div>
                  <div className="icon-bx">
                    <span className="icon-cell">
                      <img src="assets/images/icon-box/logo4.svg" alt="" />
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-md-6 wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="icon-bx-wraper style-1 box-hover">
                  <div className="icon-content">
                    <h5 className="dz-title m-b10">
                      <a href="#">
                        ₹{" "}
                        {WalletData.length > 0
                          ? parseFloat(
                              WalletData[0].refference_earning
                            ).toFixed(2)
                          : 0}
                      </a>
                    </h5>
                    <p className="m-b25">Reference Earning Wallet</p>
                  </div>
                  <div className="icon-bx">
                    <span className="icon-cell">
                      <img src="assets/images/icon-box/logo4.svg" alt="" />
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-md-6 wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="icon-bx-wraper style-1 box-hover">
                  <div className="icon-content">
                    <h5 className="dz-title m-b10">
                      <a href="#">
                        ₹{" "}
                        {WalletData.length > 0
                          ? parseFloat(
                              WalletData[0].full_total_earnings
                            ).toFixed(2)
                          : 0}
                      </a>
                    </h5>
                    <p className="m-b25">Total Earning Wallet</p>
                  </div>
                  <div className="icon-bx">
                    <span className="icon-cell">
                      <img src="assets/images/icon-box/logo4.svg" alt="" />
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-md-6 wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="icon-bx-wraper style-1 box-hover">
                  <div className="icon-content">
                    <h5 className="dz-title m-b10">
                      <a href="#">
                        ₹{" "}
                        {WalletData.length > 0
                          ? parseFloat(WalletData[0].wallet_balance).toFixed(2)
                          : 0}
                      </a>
                    </h5>
                    <p className="m-b25">Wallet Balance</p>
                  </div>
                  <div className="icon-bx">
                    <span className="icon-cell">
                      <img src="assets/images/icon-box/logo4.svg" alt="" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <svg
            className="bg-image"
            viewbox="0 0 1919 379"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M73.3165 123.52C157.912 108.819 150.516 156.618 189.162 158.467C227.762 160.317 227.762 145.616 271.909 162.166C316.056 178.715 325.208 213.663 367.506 208.115C409.804 202.614 409.804 178.715 441.054 209.965C472.303 241.214 485.201 266.963 536.651 298.212C588.149 329.462 619.398 305.562 645.147 292.711C670.895 279.86 657.998 272.464 698.447 285.361C738.895 298.212 849.193 270.661 893.34 265.114C937.487 259.613 981.588 217.315 1010.99 202.614C1040.39 187.914 1101.09 230.212 1126.83 244.912C1152.58 259.613 1178.33 239.411 1209.58 230.212C1240.83 221.013 1273.93 222.862 1329.08 198.963C1384.23 175.063 1429.11 187.637 1472.57 176.958C1535.07 161.565 1551.15 180.425 1636.12 211.814C1679.34 227.808 1679.02 227.115 1698.62 206.313C1708.14 196.189 1719.7 210.612 1733.15 213.524C1751.64 217.5 1767.64 208.901 1806.23 192.352C1837.62 178.9 1894.94 148.251 1920 156.757V373.436H0.0465088V134.614C17.844 132.442 41.9283 129.021 73.3165 123.52Z"
              fill="var(--secondary-light)"
            ></path>
            <path
              d="M747.309 336.865C747.309 336.865 760.53 330.532 761.084 321.009C755.815 321.518 746.292 331.04 746.292 331.04C746.292 331.04 751.053 318.328 742.039 310.932C740.975 318.883 744.443 330.624 744.443 330.624C744.443 330.624 742.177 327.111 736.769 325.493C737.971 329.422 740.513 333.537 747.309 336.865Z"
              fill="var(--secondary)"
            ></path>
            <path
              d="M1708.14 273.534C1708.14 273.534 1732.04 262.07 1732.96 244.873C1723.4 245.844 1706.2 263.04 1706.2 263.04C1706.2 263.04 1714.8 240.112 1698.57 226.752C1696.68 241.082 1702.92 262.301 1702.92 262.301C1702.92 262.301 1698.8 255.968 1689.05 253.055C1691.27 260.082 1695.84 267.524 1708.14 273.534Z"
              fill="var(--secondary)"
            ></path>
            <path
              d="M343.56 303.582C343.56 303.582 353.314 302.935 354.886 294.475C353.314 290.407 347.952 299.191 347.952 299.191C347.952 299.191 346.057 284.121 337.597 278.435C342.312 291.332 345.456 299.191 345.456 299.191C345.456 299.191 338.522 289.113 330.386 288.512C332.882 296.648 343.56 303.582 343.56 303.582Z"
              fill="var(--secondary)"
            ></path>
            <path
              d="M1438.27 246.676C1438.27 246.676 1448.02 246.029 1449.59 237.57C1448.02 233.502 1442.66 242.285 1442.66 242.285C1442.66 242.285 1440.76 227.215 1432.3 221.529C1437.02 234.426 1440.16 242.285 1440.16 242.285C1440.16 242.285 1433.23 232.207 1425.09 231.606C1427.59 239.742 1438.27 246.676 1438.27 246.676Z"
              fill="var(--secondary)"
            ></path>
            <path
              d="M102.624 254.257L116.539 238.263C111.407 237.246 101.607 249.08 101.607 249.08C101.607 249.08 105.722 237.754 94.9044 223.84C91.2525 237.246 102.624 254.257 102.624 254.257Z"
              fill="var(--secondary)"
            ></path>
            <path
              d="M234.557 199.849V286.201"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M259.982 204.471C259.982 217.507 255.128 223.193 235.62 222.315"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M208.716 222.547C208.716 235.583 213.57 241.269 233.078 240.391"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1025.74 221.899V308.251"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1051.16 226.521C1051.16 239.558 1046.31 245.243 1026.8 244.365"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M999.894 244.597C999.894 257.633 1004.75 263.319 1024.26 262.441"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1848.26 175.394V261.746"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1873.68 180.017C1873.68 193.053 1868.83 198.739 1849.32 197.86"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1822.41 198.092C1822.41 211.128 1827.27 216.814 1846.78 215.936"
              stroke="var(--secondary)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M111.593 249.312C144.09 234.01 144.09 232.115 174.646 258.881C205.203 285.646 235.759 283.705 235.759 283.705C235.759 283.705 298.813 274.136 348.461 302.796C398.109 331.457 407.678 350.549 476.464 354.386C545.25 358.223 741.993 329.562 787.85 329.562C833.707 329.562 803.151 348.654 854.695 327.667C906.284 306.633 885.251 302.843 975.07 299.006C1064.84 295.169 1196.68 277.972 1311.28 264.613C1425.92 251.253 1450.93 227.354 1607.74 253.657C1664.46 263.18 1732.64 268.773 1799.86 255.876C1834.48 249.219 1875.07 252.501 1919.95 263.087V378.344H0V187.229C41.8356 191.666 83.2553 262.671 111.593 249.312Z"
              fill="var(--secondary)"
            ></path>
          </svg>
          <div className="circle1 dz-parallax"></div>
        </section>
        <section className="content-inner overflow-hidden section-wrapper2">
          <div className="container">
            <div className="section-head mw-100">
              <div className="row align-items-end">
                <div className="col-md-6">
                  <h2 className="title wow fadeInUp mb-0" data-wow-delay="0.4s">
                    Withdrawal
                  </h2>
                </div>
              </div>
            </div>
            <div className="row dz-tooltip-blog">
              {UserWithdrawalCNT === 0 ? (
                <div className="col-12">
                  <div className="row align-items-center dz-info">
                    <div className="col-md-12">
                      <form>
                        <div className="form-group">
                          <label>Enter Withdrawal Amount</label>
                          <div className="row">
                            <div className="col-12">
                              <input
                                type="text"
                                placeholder="Enter Amount"
                                className="form-control"
                                value={WithDrawalAmount}
                                onChange={(event) =>
                                  setWithDrawalAmount(event.target.value)
                                }
                              />
                            </div>
                            <div className="col-12">
                              <button
                                type="button"
                                className="btn btn-primary"
                                style={{ marginTop: "5%" }}
                                onClick={WithDraw}
                              >
                                Withdraw
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-12">
                  <p style={{ fontWeight: "500", fontSize: "1.5em" }}>
                    Per day, only one withdrawal request is allowed.
                  </p>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <div className="col-md-12">
                <p
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#454545",
                    textAlign: "center",
                    borderBottom: "1px solid #afafaf",
                    paddingBottom: "3%",
                  }}
                >
                  Withdrawal History
                </p>
              </div>
              <div className="col-md-12">
                <table className="table table-hover table-stripped table-responsive">
                  {WalletDataHistory.length > 0 ? (
                    WalletDataHistory.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            width: "25%",
                            borderBottom: "1px solid #999999",
                            padding: "0",
                          }}
                        >
                          <img
                            src={"assets/images/tran.jpg"}
                            style={{ width: "80%" }}
                            alt="Transaction"
                          />
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #999999",
                            padding: "0",
                          }}
                        >
                          {item.withdrawal_status === 0 ||
                          item.withdrawal_status === "0" ? (
                            <React.Fragment>
                              <p
                                style={{
                                  color: "rgb(201 160 0)",
                                  textAlign: "left",
                                  fontWeight: "900",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Pending
                              </p>
                              <p
                                style={{
                                  marginBottom: "0",
                                  textAlign: "left",
                                  fontSize: "12px",
                                  paddingBottom: 0,
                                }}
                              >
                                {item.withdrawal_date}
                              </p>
                            </React.Fragment>
                          ) : item.withdrawal_status === 1 ||
                            item.withdrawal_status === "1" ? (
                            <React.Fragment>
                              <p
                                style={{
                                  color: "#1bb919",
                                  textAlign: "left",
                                  fontWeight: "900",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Accpted
                              </p>
                              <p
                                style={{
                                  marginBottom: "0",
                                  textAlign: "left",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                }}
                              >
                                {item.withdrawal_date}
                              </p>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <p
                                style={{
                                  color: "rgb(241 18 18)",
                                  textAlign: "left",
                                  fontWeight: "900",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Rejected
                              </p>
                              <p
                                style={{
                                  marginBottom: "0",
                                  textAlign: "left",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                }}
                              >
                                {item.withdrawal_date}
                              </p>
                            </React.Fragment>
                          )}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #999999",
                            padding: "0",
                          }}
                        >
                          <p
                            style={{
                              color: "rgb(71 71 71)",
                              textAlign: "right",
                              fontWeight: "600",
                              fontSize: "20px",
                              marginTop: "5%",
                              marginBottom: 0,
                              paddingBottom: 0,
                            }}
                          >
                            ₹ {item.withdrawal_amount}
                          </p>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ textAlign: "center", color: "#888" }}
                      >
                        No wallet data available.
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </div>
          </div>
          <svg
            className="bg-image"
            viewbox="0 0 1920 264"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M380.438 172.814C453.01 193.873 513.641 155.505 584.547 164.16C655.453 172.814 667.579 158.976 745.427 139.953C823.275 120.931 828.459 164.16 866.504 141.666C904.549 119.172 899.365 127.827 923.571 143.378C947.777 158.93 1026.27 173.972 1123.98 139.861C1174.61 122.181 1250.61 73.1669 1278.19 69.2328C1302.91 65.7153 1340.4 107.046 1380.15 91.495C1419.96 75.9439 1438.98 69.0014 1461.43 79.3689C1482.44 89.042 1505.16 76.9158 1515.72 73.1206C1522.52 72.3801 1530.81 79.9242 1548.21 81.035C1612.08 85.2005 1703.58 93.1612 1743.38 56.8753C1783.19 20.543 1817.76 -6.52413 1845.44 2.13081C1865.85 8.51788 1902.27 52.4028 1919.95 29.2527V258.093H-2.27667V214.272C17.9491 196.916 41.7386 160.853 69.0919 174.553C107.137 193.575 123 184.16 154.985 149.126C182.57 138.759 203.192 131.642 195 141.5C186.808 151.312 205.48 151.903 253.438 135.143C271.442 138.429 275.515 140.882 279.634 153.98C283.707 167.078 282.92 156.245 301.711 161.984C320.594 167.77 352.761 164.807 380.438 172.814Z"
              fill="var(--dark-light)"
            ></path>
            <path
              d="M1011.97 185.033C873.215 192.114 733.764 185.45 595.192 194.382C395.619 207.203 195.213 252.236 -2.27667 239.138V263.139H1920V104.824C1617.77 87.8385 1316.28 169.482 1011.97 185.033Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1272.36 159.464C1272.36 159.464 1248.43 147.986 1247.51 130.769C1257.09 131.741 1274.3 148.958 1274.3 148.958C1274.3 148.958 1265.7 126.002 1281.94 112.626C1283.84 126.973 1277.59 148.217 1277.59 148.217C1277.59 148.217 1281.71 141.877 1291.48 138.961C1289.25 146.042 1284.63 153.447 1272.36 159.464Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M798.422 188.632C798.422 188.632 774.494 177.154 773.568 159.936C783.148 160.908 800.366 178.125 800.366 178.125C800.366 178.125 791.757 155.169 808.003 141.793C809.9 156.141 803.652 177.385 803.652 177.385C803.652 177.385 807.771 171.044 817.537 168.128C815.315 175.163 810.733 182.615 798.422 188.632Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1552.19 120.033C1552.19 120.033 1542.42 119.385 1540.85 110.915C1542.42 106.842 1547.79 115.636 1547.79 115.636C1547.79 115.636 1549.69 100.547 1558.16 94.8545C1553.44 107.767 1550.29 115.636 1550.29 115.636C1550.29 115.636 1557.23 105.546 1565.38 104.944C1562.88 113.09 1552.19 120.033 1552.19 120.033Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M575.504 196.897C575.504 196.897 565.738 196.249 564.165 187.779C565.738 183.706 571.107 192.5 571.107 192.5C571.107 192.5 573.005 177.411 581.475 171.719C576.754 184.631 573.606 192.5 573.606 192.5C573.606 192.5 580.549 182.41 588.695 181.808C586.242 190 575.504 196.897 575.504 196.897Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1733.94 104.342L1720.01 88.3282C1725.15 87.31 1734.96 99.1586 1734.96 99.1586C1734.96 99.1586 1730.84 87.8192 1741.67 73.8879C1745.33 87.31 1733.94 104.342 1733.94 104.342Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1662.43 23.5308V110.034"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1636.98 28.1594C1636.98 41.2113 1641.84 46.9041 1661.37 46.0247"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1688.31 46.2561C1688.31 59.3079 1683.45 65.0008 1663.92 64.1214"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M117.901 158.215V244.672"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M92.445 162.844C92.445 175.896 97.3047 181.588 116.836 180.709"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M143.773 180.94C143.773 193.992 138.913 199.685 119.382 198.806"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
          </svg>
          <div className="circle1 style-1 dz-parallax"></div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default WithDrawal;
